module.exports = __webpack_public_path__ + "static/adm_komp-fcfb7c67cc81e1610bb53aa26adb253d.jpg";